<template>
  <div class="slider">
    <slick ref="slick" :options="slickOptions">
      <div v-for="item in items" :key="item.id" class="post_clm">
        <a :href="item.url" target="_blank">
          <img :src="item.image" :alt="item.title" />
        </a>
      </div>
    </slick>
  </div>
</template>

<script>
import Slick from "vue-slick";
export default {
  // 初期値設定
  data: function() {
    return {
      total_count: 0,
      items: [],
      // Slickオプション
      slickOptions: {
        cssEase: "ease-in-out",
        slidesToScroll: 1,
        slidesToShow: 1,
        speed: 1000,
        autoplaySpeed: 4000,
        centerMode: true,
        centerPadding: "20%",
        infinite: true,
        arrows: true,
        dots: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 1140,
            settings: {
              slidesToShow: 1,
              centerPadding: "1%",
              variableWidth: false,
            }
          }
        ]
      }
    };
  },
  components: { Slick },
  props: {
    type: String
  },
  methods: {
    getSliders() {
      const data = {
        type: this.type
      };
      var self = this;
      axios
        .post("/api/sliders", data)
        // 成功時処理
        .then(res => {
          self.total_count = res.data.total_count;
          self.items = res.data.items;
        })
        // エラーレスポンス時処理
        .catch(error => {
          console.log(error);
        });
    }
  },
  next: function() {
    this.$refs.slick.next();
  },
  prev: function() {
    this.$refs.slick.prev();
  },
  reInit: function() {
    this.$nextTick(() => {
      this.$refs.slick.reSlick();
    });
  },
  created: function() {
    this.getSliders();
  },
  beforeUpdate: function() {
    if (this.$refs.slick) {
      this.$refs.slick.destroy();
    }
  },
  updated: function() {
    this.$nextTick(function() {
      if (this.$refs.slick) {
        this.$refs.slick.create(this.slickOptions);
      }
    });
  }
};
</script>